export default "__VITE_ASSET__7002a9cb__"